
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[robot]",
      function () {
        return require("private-next-pages/products/[robot].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[robot]"])
      });
    }
  